export default {"src":"/_next/static/media/digi_locker.530f6f9d.svg","height":224,"width":264,"blurWidth":0,"blurHeight":0};